import { useNavigate } from "react-router-dom";
import { useApp } from "../lib/store";
import { ListPage } from "../components/ListPage";
import { Badge } from "../components/ui/badge";
import { fmtEur, fmtDate } from "../lib/api";
import { SEVERITY_COLORS } from "../lib/fields";
import { trackRecent } from "../components/Layout";
import { AlertTriangle } from "lucide-react";

export default function Complaints() {
  const { t } = useApp();
  const navigate = useNavigate();
  const columns = [
    { key: "complaint_number", label: "#", render: (r) => (
      <span className="font-mono font-medium text-[#1B2A4A] flex items-center gap-1.5">
        {r.sla_overdue && <AlertTriangle className="h-3.5 w-3.5 text-red-500" data-testid="sla-overdue-flag" />}
        {r.complaint_number}
      </span>) },
    { key: "account_name", label: t("account") },
    { key: "defect_category", label: t("defect_category"), picklist: "defect_categories" },
    { key: "severity", label: t("severity"), picklist: "severities", render: (r) => <Badge className={`${SEVERITY_COLORS[r.severity] || ""} hover:bg-inherit`}>{r.severity}</Badge> },
    { key: "status", label: t("status"), render: (r) => (
      <Badge className={r.sla_overdue ? "bg-red-100 text-red-700 hover:bg-red-100" : r.status?.startsWith("Closed") ? "bg-emerald-50 text-emerald-700 hover:bg-emerald-50" : "bg-blue-50 text-blue-700 hover:bg-blue-50"}>
        {r.status}{r.sla_overdue ? ` · ${t("overdue")}` : ""}
      </Badge>) },
    { key: "claimed_value", label: t("claimed_value"), align: "right", render: (r) => fmtEur(r.claimed_value) },
    { key: "date_received", label: t("date_received"), render: (r) => fmtDate(r.date_received) },
    { key: "owner_name", label: t("owner") },
  ];
  return (
    <ListPage module="complaints" titleKey="complaints" columns={columns} formSubtitle={t("complaint_new_subtitle")}
      onRowClick={(r) => { trackRecent(r.complaint_number, `/complaints/${r.id}`); navigate(`/complaints/${r.id}`); }} />
  );
}
